module.exports = __webpack_public_path__ + "static/media/icon_107.1e659179.svg";